import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=4695c724&scoped=true"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4695c724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4695c724')) {
      api.createRecord('4695c724', component.options)
    } else {
      api.reload('4695c724', component.options)
    }
    module.hot.accept("./addEdit.vue?vue&type=template&id=4695c724&scoped=true", function () {
      api.rerender('4695c724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/shouldSendDataMonitoring/cmp/addEdit.vue"
export default component.exports